//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmFooter from '@/components/cmFooter.vue'

export default {
  name: 'work',
  components: {
      cmFooter
  },
  data () {
    return {
      type:0,
      grade:0,
      count:[],
      info:{}
    }
  },
  created(){
    this.grade = parseInt(this.$func.getLocal('grade'));
    if(this.grade == 23 || this.grade == 24){
      this.getInfo();
    }
  },
  mounted(){
    this.getCurtainOrderCount();

  },
  methods:{

    getCurtainOrderCount(){
      this.$api.getCurtainOrderCount({}).then((res)=>{
        this.count = res.data;
      })
    },
    getInfo(){
      this.$api.getInfo({}).then((res)=>{
        if(res){
          this.info = res.data;
          console.log(res.data);
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/curtain.vue